"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Heading: function() {
        return Heading;
    },
    default: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _styled = /*#__PURE__*/ _interop_require_default(require("../../styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n  position: relative;\n  display: block;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        "\n  position: absolute;\n  top: 14px;\n  font-size: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var HeadingContainer = _styled.default.div(_templateObject(), function(props) {
    return props.color;
});
var Subtitle = _styled.default.div(_templateObject1(), function(props) {
    return props.color;
});
var Heading = function(param) {
    var as = param.as, children = param.children, subtitle = param.subtitle, subtitleColor = param.subtitleColor, color = param.color, margin = param.margin, padding = param.padding, lineHeight = param.lineHeight;
    var HeadingElement = as;
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(HeadingContainer, {
        color: color != null ? color : "#000000",
        children: [
            subtitle && /*#__PURE__*/ (0, _jsxruntime.jsx)(Subtitle, {
                color: subtitleColor != null ? subtitleColor : "#000000",
                children: subtitle
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)(HeadingElement, {
                style: {
                    padding: padding,
                    margin: margin,
                    lineHeight: lineHeight
                },
                children: children
            })
        ]
    });
};
var _default = Heading;
